// src/pages/ProspeccaoB2B.js

import React, { useState } from 'react';
import { storage } from '../firebase'; // Verifique se o caminho do seu firebase.js está correto
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { useAuth } from '../context/AuthContext';

const ProspeccaoB2B = () => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState('');
  const { currentUser } = useAuth();

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.name.endsWith('.csv')) {
      setFile(selectedFile);
      setMessage('');
    } else {
      setFile(null);
      setMessage('Erro: Selecione apenas arquivos no formato .csv');
    }
  };

  const handleUpload = async () => {
    if (!file) {
      setMessage('Nenhum arquivo selecionado.');
      return;
    }

    setUploading(true);
    setMessage('');
    setProgress(0);

    // O caminho EXATO que definimos nas regras de segurança
    const storageRef = ref(storage, `uploads_prospeccao/${file.name}`);

    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      'state_changed',
      (snapshot) => {
        // Calcula o progresso do upload
        const progressPercent = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        setProgress(progressPercent);
      },
      (error) => {
        console.error('Erro no upload:', error);
        setMessage(`Erro no upload: Você tem permissão? (${error.message})`);
        setUploading(false);
      },
      () => {
        // Upload concluído com sucesso
        setMessage('Upload concluído com sucesso! O Back-end já iniciou o processamento da base.');
        setUploading(false);
        setFile(null);
        
        // Aqui o arquivo já caiu no Storage e a Cloud Function (Passo 2) vai assumir o trabalho sozinha.
      }
    );
  };

  return (
    <div style={{ padding: '40px', maxWidth: '800px', margin: 'auto' }}>
      <h1>Gestão de Leads B2B (Receita Federal)</h1>
      <p>Faça o upload do arquivo <strong>Estabelecimentos.csv</strong>. O sistema processará os dados em nuvem, extrairá os e-mails válidos e iniciará a esteira de prospecção autônoma (Dia 0 e Mês 10).</p>

      <div style={{
        border: '2px dashed #ccc', padding: '40px', textAlign: 'center', 
        borderRadius: '8px', backgroundColor: '#f9f9f9', marginTop: '20px'
      }}>
        <input 
          type="file" 
          accept=".csv" 
          onChange={handleFileChange} 
          disabled={uploading}
          style={{ display: 'block', margin: '0 auto 20px auto' }}
        />
        
        {file && (
          <p>Arquivo selecionado: <strong>{file.name}</strong> ({(file.size / (1024 * 1024)).toFixed(2)} MB)</p>
        )}

        <button 
          onClick={handleUpload} 
          disabled={!file || uploading}
          style={{
            backgroundColor: file && !uploading ? '#007bff' : '#ccc',
            color: 'white', padding: '10px 20px', border: 'none', 
            borderRadius: '5px', cursor: file && !uploading ? 'pointer' : 'not-allowed',
            fontWeight: 'bold', marginTop: '10px'
          }}
        >
          {uploading ? `Enviando para a Nuvem (${progress}%)...` : 'Processar Base de Dados'}
        </button>
      </div>

      {progress > 0 && progress < 100 && (
        <div style={{ width: '100%', backgroundColor: '#e0e0e0', borderRadius: '5px', marginTop: '20px' }}>
          <div style={{ width: `${progress}%`, backgroundColor: '#007bff', height: '10px', borderRadius: '5px' }}></div>
        </div>
      )}

      {message && (
        <div style={{ 
          marginTop: '20px', padding: '15px', borderRadius: '5px',
          backgroundColor: message.includes('Erro') ? '#fee2e2' : '#dcfce7',
          color: message.includes('Erro') ? '#991b1b' : '#166534'
        }}>
          {message}
        </div>
      )}
    </div>
  );
};

export default ProspeccaoB2B;